<template>
  <section>
    <!-- Page content-->
    <div class="content-wrapper">
      <div class="content-heading">
        Account Suspended
        <small data-localize="dashboard.WELCOME"></small>
      </div>
      <div class="row">
        <spinner v-if="loading"></spinner>

        <div class="col-lg-12">
          <div id="panelChart9" class="panel panel-default">
            <p>
              Your account has been suspended. Please contact the Calvert Impact Capital for more details at <a href="mailto:info@calvertimpact.org">info@calvertimpact.org</a> or <a href="tel:+18002480337">800.248.0337</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import Spinner from '@/components/widgets/Spinner';

  export default {
    name: 'accountSuspended',
    data() {
      return {
        loading: false,
      };
    },
    beforeMount() {
      this.checkUserStatus();
    },
    components: {
      spinner: Spinner,
    },
    computed: {
      ...mapState('app', [
        'activeAccount',
        'user',
      ]),
    },
    methods: {
      ...mapActions('home', [
        'getUserStatus',
      ]),
      async checkUserStatus() {
        this.loading = true;
        return this.getUserStatus({
          accountId: this.activeAccount.id,
        })
          .then(({ status }) => {
            if (status !== 'suspended') {
              this.$router.push({ name: 'Home' });
            }
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
      },
    },
  };
</script>
<style>
</style>



// WEBPACK FOOTER //
// AccountSuspended.vue?e6c2bb68